(function() {
	'use strict';

	angular
		.module('pwc.model')
		.service('WineSale', WineSale);

	WineSale.$inject = ['$window', 'BaseModel', 'Transaction'];

	function WineSale($window, BaseModel, Transaction) {

		// Entity Defaults
		var defaults = $window.stampit().state({
			"type": "sale",
			"buyer": null,
			"consigner": null,
			"date": new Date(),
			"notes": null,
			"price": 0.00,
			"qty": 1,
			"total": 0.00
		});

		var WineSaleFactory = $window.stampit().enclose(function () {

			this.getSummary = function(){
				var summary = 'You sold ' + this.qty + ' bottle' + (this.qty > 1 ? 's ' : ' ');

				if (this.buyer){
					summary +=  'to ' + this.buyer + ' ';
				}

				return summary + ' for ' + this.getFormattedCurrency(this.price) + ' per bottle.';
			};

			return $window.stampit.mixIn(this, BaseModel, Transaction);

		});

		return function(properties){
			return $window.stampit.compose(defaults, WineSaleFactory).create(properties);
		};

	}

})();
